"use client";
import * as React from "react";
import { Box, Container, SxProps, Theme } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNewRounded";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalkRounded";
import MailIcon from "@mui/icons-material/MailOutlineRounded";
import ArrowIcon from "@mui/icons-material/EastRounded";

import Image from "next/image";

import Link from "next/link";
import SocialIcons from "../home-redesigned/SocialIcons";

const Footer: React.FC = () => {
  return (
    <>
      <Box
        component={"footer"}
        sx={{
          bgcolor: "primary.main",
          color: "#fff",
        }}
      >
        <Container>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "0.75fr 1.75fr 1fr" },
              gap: "2rem",
              mt: "1rem",
            }}
          >
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", xl: "flex-start" },
                textAlign: { xs: "center", xl: "left" },
              }}
            >
              <Image
                src="/images/logo/wcv-logo-edited-red-white.png"
                alt="World Cruise Vibes"
                width={200}
                height={50}
                loader={({ src }) => src}
              />

              <Box
                sx={{
                  fontWeight: 100,
                  fontSize: "14px",
                  color: "primary.light",
                  mt: "10px",
                }}
              >
                14 Cricklewood Ln <br />
                London NW2 1EX, <br />
                United Kingdom.
              </Box>

              <Box sx={{ width: "100%", mt: "2rem" }}>
                <Box
                  sx={{
                    color: "#fff",
                    fontSize: "1rem",
                    fontWeight: 600,
                    mb: "10px",
                    mt: { xs: "10px", xl: "0px" },
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                  }}
                >
                  Follow Us for Exclusive Updates!
                </Box>

                <Box>
                  <SocialIcons
                    sx={{ justifyContent: { xs: "center", xl: "flex-start" } }}
                    socialPlatform={["google", "twitter", "facebook"]}
                  />
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ mb: "10px", fontWeight: 700, fontSize: "18px" }}>Quick links</Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    md: "1fr 1fr",
                    xl: "1fr 1fr 1fr",
                  },
                  gap: "8px 10px",
                  a: {
                    textDecoration: "none",
                  },
                }}
              >
                <FooterLinkButton label="Destinations" link="/cruise-destinations" />
                <FooterLinkButton label="About Us" link="/about-us" />
                <FooterLinkButton label="Terms and Conditions" link="/help-and-support" />

                <FooterLinkButton label="Contact Us" link="/contact-us" />
                <FooterLinkButton label="Privacy Policy" link="/privacy-policy" />

                <FooterLinkButton label="Explore Ships" link="/best-cruise-ships" />
                <FooterLinkButton label="Members Only" link="/members-only" />

                <FooterLinkButton label="Help and Support" link="/help-and-support" />
                <FooterLinkButton label="Cookie Policy" link="/cookie-policy" />
                <FooterLinkButton label="Pay Online" link="/payment" />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "flex-start", md: "flex-end" },
              }}
            >
              <Box>
                <Box
                  sx={{
                    fontSize: "1rem",
                    fontWeight: 600,
                    mb: "16px",
                  }}
                >
                  Need help with reservations?
                  <br /> Our expert travel team is here to assist you.
                </Box>
                <Link href="tel:+442081253546" passHref>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                      svg: {
                        width: "28px",
                        height: "28px",
                      },
                      mb: "1rem",
                      border: "1px solid #fff",
                      p: "6px 8px",
                      borderRadius: "10px",
                    }}
                  >
                    <PhoneInTalkIcon />
                    <Box>
                      <Box sx={{ fontWeight: 400, fontSize: "13px" }}>Call us on</Box>
                      <Box sx={{ fontWeight: 700, fontSize: "18px" }}>020 8125 3546</Box>
                    </Box>
                  </Box>
                </Link>

                <Link href="mailto:info@worldcruisevibes.com" passHref>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "7px",
                      alignItems: "center",
                      svg: {
                        width: "28px",
                        height: "28px",
                      },
                      mb: "1rem",
                      border: "1px solid #fff",
                      p: "6px 8px",
                      borderRadius: "10px",
                    }}
                  >
                    <MailIcon />
                    <Box>
                      <Box sx={{ fontWeight: 400, fontSize: "13px" }}>Email to</Box>
                      <Box sx={{ fontWeight: 700, fontSize: "18px" }}>
                        info@worldcruisevibes.com
                      </Box>
                    </Box>
                  </Box>
                </Link>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column-reverse", md: "row" },
              justifyContent: "space-between",
              alignItems: "center",
              fontWeight: 400,
              fontSize: "14px",
              mt: "2rem",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Box
              component={"a"}
              href="https://www.scripterlab.com/"
              target="_blank"
              sx={{
                m: { xs: "2rem 0px 1.5rem", md: "0px" },
              }}
            >
              Powered by
              <Box
                component={"span"}
                sx={{
                  // background:
                  //   "-webkit-linear-gradient(0deg, rgb(101, 204, 156) 0%, rgb(104, 202, 88) 100%) text",
                  // WebkitTextFillColor: "transparent",
                  ml: "4px",
                  fontWeight: 600,
                  fontSize: "15px",
                  color: "#ff6b41",
                }}
              >
                Scripterlab
              </Box>
            </Box>
            <Box>
              © {new Date().getFullYear()} Vibes Group UK. All rights reserved. Trading as World
              Cruise Vibes.
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Footer;

export const FooterLinkButton: React.FC<{
  label: string | React.ReactNode;
  link?: string;
  isMobileMenu?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}> = ({ label, link, isMobileMenu, onClick, sx }) => {
  return (
    <Link href={link ? link : ""} onClick={!!onClick ? onClick : () => {}}>
      <Box
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          border: "1px solid #4845AD",
          bgcolor: "#030053",
          borderRadius: "20px",
          p: "8px 14px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          lineHeight: 1.3,
          "&:hover": {
            color: "primary.main",
            bgcolor: "primary.light",
          },
          svg: {
            color: "#4845AD",
          },
          ...(isMobileMenu && {
            borderRadius: "0px",
            bgcolor: "unset",
            fontSize: { xs: "26px", md: "18px" },
            fontWeight: 600,
            p: "2px 0px 12px",
            border: "none",
            borderBottom: "1px solid #4845AD",
            fontFamily: "'blauerNue', 'blauerNue Fallback'",
            ".arrow_icon": {
              color: "#6c67ff",
              width: "30px",
              height: "30px",
            },
          }),
          ...sx,
        }}
      >
        <Box>{label}</Box>
        {isMobileMenu ? (
          <ArrowIcon className="arrow_icon" />
        ) : (
          <OpenInNewIcon className="arrow_icon" />
        )}
      </Box>
    </Link>
  );
};
